import { render, staticRenderFns } from "./InboxItemDesktop.vue?vue&type=template&id=fa47846e&scoped=true&"
import script from "./InboxItemDesktop.vue?vue&type=script&lang=js&"
export * from "./InboxItemDesktop.vue?vue&type=script&lang=js&"
import style0 from "./InboxItemDesktop.vue?vue&type=style&index=0&id=fa47846e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa47846e",
  null
  
)

export default component.exports